import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function setClientUnit(data: { unit_id: string; pass: string }) {
  const response = await http.postData(`/unit-setting`, data).catch(err => {
    console.log("error...", err);
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

export default {
  setClientUnit
};
